module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-content"
  }, [_c('div', {
    staticClass: "cls-content panel"
  }, [_vm._m(0), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入密码",
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "checkbox pad-btm text-left"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登 录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pad-all"
  }, [_c('a', {
    staticClass: "btn-link mar-rgt",
    staticStyle: {
      "margin-right": "30px"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.userGuide
    }
  }, [_vm._v("使用手册")]), _vm._v(" "), _c('a', {
    staticClass: "btn-link mar-lft",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.registerAccount
    }
  }, [_vm._v("注册帐号")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mar-ver pad-btm"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "20px",
      "color": "#ffffff",
      "position": "relative",
      "bottom": "20px"
    }
  }, [_vm._v("基于地图的社交平台")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6573d8c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 210
// module chunks = 1